'use client'

import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from '@mui/material'
import { type ReactNode } from 'react'
import { RefinementUiConfig } from '../types'

type SearchRefinementAccordionProps = RefinementUiConfig & {
  children: ReactNode
  defaultExpanded?: boolean
  disabled?: boolean
}

export function SearchRefinementAccordion({
  label,
  icon,
  children,
  defaultExpanded = false,
  disabled = false,
}: SearchRefinementAccordionProps) {
  return (
    <Accordion
      defaultExpanded={defaultExpanded}
      disabled={disabled}
      disableGutters
      elevation={0}
      classes={{
        root: 'border-t border-divider-light bg-transparent before:hidden first:border-t-0',
        expanded: 'm-0',
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon sx={{ fontSize: 16 }} />}
        classes={{
          root: 'min-h-0 flex-row gap-1 p-0 py-4 break-all hyphens-auto',
          expandIconWrapper: 'ml-auto rotate-180',
          content: 'm-0 gap-1 items-center',
          expanded: '[&>.MuiAccordionSummary-expandIconWrapper]:rotate-0',
        }}
      >
        <div className="flex h-[22px] w-[22px] shrink-0 items-center justify-center">
          {icon}
        </div>
        <Typography className="font-sans text-base font-medium leading-[18px] text-mydra-black">
          {label}
        </Typography>
      </AccordionSummary>

      <AccordionDetails className="p-0 pb-2">{children}</AccordionDetails>
    </Accordion>
  )
}
